import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ClaimLineTypesConfiguration,
  CLAIM_LINE_TYPES_CONFIGURATION
} from './tokens/claim-line-types.Configuration';
import { ClaimLinesConverterService } from './services';

@NgModule({
  imports: [CommonModule]
})
export class SharedBackOfficeClaimsUtilsTransformationsModule {
  static forRoot(
    configuration: ClaimLineTypesConfiguration
  ): ModuleWithProviders {
    return {
      ngModule: SharedBackOfficeClaimsUtilsTransformationsModule,
      providers: [
        {
          provide: CLAIM_LINE_TYPES_CONFIGURATION,
          useValue: configuration
        },
        ClaimLinesConverterService
      ]
    };
  }
}
